<app-header navScreen="Home" class="mb-5"></app-header>
<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>
<!-- <div class="ka-lst-title">
    <span>LST</span>
</div> -->

<div style="margin-top: 5rem;">
  <mat-accordion class="mt-5">
    <mat-expansion-panel [expanded]="expanded" (afterExpand)="expanded = !expanded" style="overflow: visible;">
        <mat-expansion-panel-header class="bg-header" [collapsedHeight]="'30px'" [expandedHeight]="'30px'">
            <mat-panel-title class="panel-title">LST</mat-panel-title>
          </mat-expansion-panel-header>
  
          <form [formGroup]="lstForm" class="row" (ngSubmit)="submitLst()">
            <div class="col-md-3 flexRows">
                <div class="inputBox customMultiSelect">
                    <p class="text-left">From Date</p>
                    <input matInput [matDatepicker]="picker" [max]="maxDate" class="form-control ka-disabled" placeholder="From Date"
                      formControlName="fromRegistrationDate">
                    <mat-datepicker-toggle matSuffix [for]="picker"
                      style="position: absolute;margin-left: 75%;margin-top: -50px;"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <!-- <div *ngIf="generalFormSearch.controls['dateOfBirthFrom'].errors && !generalFormSearch.controls['dateOfBirthFrom'].pristine "
                    class="error-msg1">
                    <div>Date of Birth is required.</div>
                  </div> -->
                  </div>
            </div>
            <div class="col-md-3">
                <div class="inputBox customMultiSelect">
                    <p class="text-left">To Date</p>
                    <input matInput [matDatepicker]="picker1" [max]="maxDate" class="form-control ka-disabled" placeholder="To Date"
                      formControlName="toRegistrationDate">
                    <mat-datepicker-toggle matSuffix [for]="picker1"
                      style="position: absolute;margin-left: 75%;margin-top: -50px;"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                    <!-- <div *ngIf="generalFormSearch.controls['dateOfBirthTo'].errors && !generalFormSearch.controls['dateOfBirthTo'].pristine "
                   class="error-msg1">
                <div>Date of Birth is required.</div>
              </div> -->
                  </div>
            </div>
            
            <!-- <div class="col-md-3" *ngIf="isAdmin === 1 || isLstAccess === 1">
                <div class="inputBox customMultiSelect">
                    <p class="text-left">Profile Owners </p>
                     (onSelect)="onSelectEmployee($event)" (onDeSelect)="onEmpDeSelect($event)" -->
                    <!-- <ng-multiselect-dropdown [placeholder]="'Any'" [settings]="multiDropdownSettings2"
                        class="col-md-5 m-0 p-0" [data]="empNameMultiSelectItems" formControlName="profileOwner">
                    </ng-multiselect-dropdown> -->
                    
                    <!-- <select id="name" formControlName="profileOwner" class="form-select ka-dropdown-singleSelect" aria-label="Default select example">
                      <option class="select-option" *ngFor="let owner of empNameMultiSelectItems" [ngValue]="owner">{{owner.value}}</option>      
                    </select>
                </div>
            </div> --> 

            <div class="col-md-3" *ngIf="isAdmin === 1 || isLstAccess === 1">
              <div class="inputBox customMultiSelect">
                <p class="text-left">Profile Owners </p>          
                <ng-multiselect-dropdown 
                  [placeholder]="'Select Profile Owners'" 
                  [settings]="multiDropdownSettings2"
                  [data]="empNameMultiSelectItems" 
                  formControlName="profileOwner" 
                  (onSelect)="onSelectEmployee($event)" 
                  (onDeSelect)="onDeSelectEmployee($event)"
                  (onSelectAll)="onEmployeeSelectAll($event)" (onDeSelectAll)="onEmployeeDeSelectAll($event)">
                </ng-multiselect-dropdown>
              </div>
            </div>
  
            <div class="col-md-3">
                <button mdbBtn
                class="ka-white-button ka-btn-primary btn-success btn mt-4"
                style="width:auto; border-radius: 30px;" mdbWavesEffect type="submit"> Submit </button>
            </div>
        </form>
    </mat-expansion-panel>
  </mat-accordion>
  
  
  <div class="profile-grid">
  <div class='lst-filter-icon'>
    <div class="mb-2" class="ka-emp-lstIcons" *ngIf="allDisplayValues.length>0">
      <span class="left-icons">Myside:</span>
      <input type="radio" name="search1" value="view" style="margin-left: 6px; margin-top: 4px;"
          (change)="filter1($event)" matTooltip="Service viewed by Clients"/>
      <i class="fa fa-eye" aria-hidden="true"
          style="padding-left: 0%; padding-top: 3px;"></i> <span *ngIf="search1 == 'view'">({{displayValues.length}})</span>
      <input type="radio" name="search1" value="noView" style="margin-left: 6px; margin-top: 4px;"
          (change)="filter1($event)" matTooltip="Service not viewed by Clients"/>
      <i class="fa fa-eye-slash" aria-hidden="true"
          style="padding-left: 0%; padding-top: 3px;"></i> <span *ngIf="search1 == 'noView'">({{displayValues.length}})</span>
      <input type="radio" name="search1" value="interested" style="margin-left: 6px; margin-top: 4px;"
          (change)="filter1($event)" matTooltip="My clients interested profiles"/>
          <span style="width: 35px;"><img style="width: 28px;" src="../../../assets/img/communication/Interested_red.png">
              </span> <span *ngIf="search1 == 'interested'">({{displayValues.length}})</span>
          
          <input type="radio" name="search1" value="notInterested" style=" margin-top: 6px;"
          (change)="filter1($event)" matTooltip="My clients not interested profiles"/>
      <span style="width: 35px;"><img style="width: 28px;" src="../../../assets/img/communication/NotInterested_red.png">
          </span> <span *ngIf="search1 == 'notInterested'">({{displayValues.length}})</span>
  
    <input type="radio" name="search1" value="followUp" style=" margin-top: 6px;"
          (change)="filter1($event)" matTooltip="Follow-up done by me"/>
      <span style="width: 35px;"><img style="width: 20px;" src="../../../assets/img/communication/wrong.png">
          </span> <span *ngIf="search1 == 'followUp'">({{displayValues.length}})</span>
  
          <input type="radio" name="search1" value="notFollowUp" style=" margin-top: 6px;"
          (change)="filter1($event)" matTooltip="Not followed up by me"/>
      <span style="width: 35px;"><img style="width: 20px;" src="../../../assets/img/communication/right.png">
          </span> <span *ngIf="search1 == 'notFollowUp'">({{displayValues.length}})</span>
      
    </div>
  
    <div class="mb-2" class="ka-emp-lstIconsCenter" *ngIf="allDisplayValues.length>0">
      <input type="radio" name="search1" value="home" id="home1" style="margin-left: 6px; margin-top: 4px;" checked
          (change)="filter1($event)" matTooltip=" My Total Follow ups"/>
      <i class="fa fa-home lstHomeIcon" aria-hidden="true" for="home1"></i> <span *ngIf="search1 == 'home'">({{displayValues.length}})</span>
      
  
      <input type="radio" name="search1" value="bothInterested" style="margin-left: 6px; margin-top: 4px;"
          (change)="filter1($event)" matTooltip="Mutually Interested Profiles"/>
          <!-- <span style="width: 35px;"><img style="width: 28px;" src="../../../assets/img/communication/Interested_red.png">
              </span> -->
          <span style="width: 65px;"><img style="width: 54px;" src="../../../../assets/img/communication/Mutual acceptance.png">
              </span> <span *ngIf="search1 == 'bothInterested'">({{displayValues.length}})</span>
      
    </div>

    <div class="mb-2" class="ka-emp-lstIcons" *ngIf="allDisplayValues.length>0">
      <span class="left-icons">Otherside:</span>
      <input type="radio" name="search1" value="view" style="margin-left: 6px; margin-top: 4px;"
          (change)="filter3($event)" matTooltip="Opposite Client Viewed"/>
      <i class="fa fa-eye" aria-hidden="true"
          style="padding-left: 0%; padding-top: 3px;"></i> <span *ngIf="search2 == 'view'">({{displayValues.length}})</span>
      <input type="radio" name="search1" value="noView" style="margin-left: 6px; margin-top: 4px;"
          (change)="filter3($event)" matTooltip="Opposite Client Not Viewed"/>
      <i class="fa fa-eye-slash" aria-hidden="true"
          style="padding-left: 0%; padding-top: 3px;"></i> <span *ngIf="search2 == 'noView'">({{displayValues.length}})</span>
      <input type="radio" name="search1" value="interested" style="margin-left: 6px; margin-top: 4px;"
          (change)="filter3($event)" matTooltip="Opposite Client Interested Profiles"/>
          <span style="width: 35px;"><img style="width: 28px;" src="../../../assets/img/communication/Interested_red.png">
              </span> <span *ngIf="search2 == 'interested'">({{displayValues.length}})</span>
          
          <input type="radio" name="search1" value="notInterested" style=" margin-top: 6px;"
          (change)="filter3($event)" matTooltip="Opposite Client not Interested Profiles"/>
          <span style="width: 35px;"><img style="width: 28px;" src="../../../assets/img/communication/NotInterested_red.png">
          </span> <span *ngIf="search2 == 'notInterested'">({{displayValues.length}})</span>
  
          <input type="radio" name="search1" value="followUp" style=" margin-top: 6px;"
          (change)="filter3($event)" matTooltip="Followed up done by Opposite RM's"/>
            <span style="width: 35px;"><img style="width: 20px;" src="../../../assets/img/communication/wrong.png">
          </span> <span *ngIf="search2 == 'followUp'">({{displayValues.length}})</span>
  
          <input type="radio" name="search1" value="notFollowUp" style=" margin-top: 6px;"
          (change)="filter3($event)" matTooltip="Not followed up by opposite RM's"/>
            <span style="width: 35px;"><img style="width: 20px;" src="../../../assets/img/communication/right.png">
          </span>  <span *ngIf="search2 == 'notFollowUp'">({{displayValues.length}})</span>
      
    </div>
  </div>
  
    <app-grid *ngIf="displayValues.length > 0" [data]="displayValues" [defaultColumns]="headers" (navigateBack)="resetSearch($event)" [formValue]="formValue" [type]="gridType2"
      [matchedHeaders]="matchedHeaders" [displayedColumns]="allheaders" [multiSelectItems]="totalFields" [selectedItems]="matchedHeaders" [profileTypeArray]="profileTypeArray"
      (openMatchFollowupTicket)="openTicketModalView($event)" (resendComMail)="resendComEmail($event)" [scrollDown]="scrollDown">
    </app-grid>
  
    <div class="lst-loadmore-container" *ngIf="displayValues.length >= 100 && !loadedAllData">
        <span (click)="loadMore()" class="lst-loadmore">Load More</span>
    </div>
  
    <div class="no-records" [hidden]="displayValues.length !== 0">
        No Records Found
    </div>
  </div>
</div>



<div mdbModal #commonModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
  aria-hidden="true" [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}" style="z-index: 999;">
  <div class="modal-dialog modal-lg" role="document">

    <div class="modal-content" style="overflow: auto; height: 500px;">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeTicketMatchModal()"
        style="position: fixed; right: 25px !important;">
        <span aria-hidden="true" class="">&times;</span>
      </button>
      <div class="row text-left">

        <!--Grid column-->
        <div class="col-md-12">

          <div class="row p-0 m-0">

            <div class="col-md-12 p-0 m-0" *ngIf="isTicketCreteClicked">
              <app-ticketcreation [isDisplayInterested]="true" [data]="ticketData" [type]='type' (ticketScreen)="closeTicketModal($event)"></app-ticketcreation>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myBasicModalLabel" aria-hidden="true"
    [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="successModal.hide()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <div class="row text-left">

                <!--Grid column-->
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                            <p class="mt-2 p-0">{{responseMessage}} </p>
                            <div class="action-buttons">
                                <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                                    mdbWavesEffect type="submit" (click)="successModal.hide()">ok
                                </button>

                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>